import { render, staticRenderFns } from "./usergroup-install-order.vue?vue&type=template&id=00b76cae&"
import script from "./usergroup-install-order.vue?vue&type=script&lang=js&"
export * from "./usergroup-install-order.vue?vue&type=script&lang=js&"
import style0 from "./usergroup-install-order.vue?vue&type=style&index=0&id=00b76cae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports